import { momentToString } from '@shared/innmaxLib/utils/webHelper'
import React from 'react'
import { useArticleStatusEnumText } from './articles.enum'

export const useConvertArticle = () => {
  const { enumToText } = useArticleStatusEnumText()

  const converter = React.useCallback((data: any) => {
    if (!data) {
      return null
    }

    return {
      ...data,
      createAtStr: data.createAt ? momentToString(data.createAt) : null,
      publishAtStr: data.publishAt ? momentToString(data.publishAt) : null,
      statusStr: enumToText(data.status),
      isFrontPageStr: !!data.isFrontPage ? '是' : '否',
    }
  }, [])

  return {
    converter,
  }
}
